const state = {
  serverNotifications: [],
  activeServerNotifications: []
}

const getters = {
  serverNotifications: state => {
    return state.serverNotifications
  },
  activeServerNotifications: state => {
    return state.activeServerNotifications
  }
}

const mutations = {
  setServerNotifications: (state, payload) => {
    state.serverNotifications = payload
  },
  setActiveServerNotifications: (state, payload) => {
    state.activeServerNotifications = payload
  },
  addServerNotification: (state, payload) => {
    state.serverNotifications.push(payload)
  },
  updateServerNotification: (state, payload) => {
    // Find the index
    const index = state.serverNotifications.findIndex(notification => notification.id === payload.id)
    // If the order exists in the array, update it
    if (index !== -1) {
      state.serverNotifications.splice(index, 1, payload)
    }
  },
  deleteServerNotification: (state, payload) => {
    const index = state.serverNotifications.findIndex(notification => notification.id === payload.id)
    state.serverNotifications.splice(index, 1)
  }
}

const actions = {
  setServerNotifications: ({ commit }, payload) => {
    commit('setServerNotifications', payload)
  },
  setActiveServerNotifications: ({ commit }, payload) => {
    commit('setActiveServerNotifications', payload)
  },
  addServerNotification: ({ commit }, payload) => {
    commit('addServerNotification', payload)
  },
  updateServerNotification: ({ commit }, payload) => {
    commit('updateServerNotification', payload)
  },
  deleteServerNotification: ({ commit }, payload) => {
    commit('deleteServerNotification', payload)
  }
}

export default {
  namespaced: true, // Optionally set to true if you want namespacing
  state,
  getters,
  mutations,
  actions
}
